module.exports = __webpack_public_path__ + "images/category_lp/common/crown-2@2x_2cad596ccaf775e10653a36f929da4b4.png";